import React from 'react';
import SelectionList from '../../../shared/components/SelectionList';
import _ from 'lodash';
import SelectionCheckbox from '../SelectionCheckbox';

const MAX_PRACTICE_GROUP_LEVEL = 5;

/**
 * @typedef {object} PracticeGroupLevelSelectionProps
 * @property {Object} [practiceGroupLevel]
 * @property {(practiceGroupLevel: { label: string, value: number | string } | Array<{ label: string, value: number | string }> | null) => void} [setPracticeGroupLevel]
 * @property {Object} [selectedPracticeArea]
 * @property {boolean} includeHigherLevels
 * @property {(includeHigherLevels: boolean) => void} setIncludeHigherLevels
 */

/**
 * @param {PracticeGroupLevelSelectionProps} props
 */
const PracticeGroupLevelSelection = props => {
  const {
    practiceGroupLevel,
    setPracticeGroupLevel,
    selectedPracticeArea,
    includeHigherLevels,
    setIncludeHigherLevels
  } = props;

  const maxLevel =
    _.maxBy(selectedPracticeArea?.Practices, p => p.PracticeGroup.Level)?.PracticeGroup.Level || 0;

  const practiceGroupLevelOptions = getPracticeGroupLevelOptions(maxLevel);

  return (
    <div className='appraisal-view-customization__section'>
      <SelectionList
        key={practiceGroupLevel}
        id='select-practice-group-level'
        showInputEndAdornment={false}
        allowAutocomplete={false}
        disabled={!selectedPracticeArea}
        label='Practice Group Level'
        onSelectHandler={setPracticeGroupLevel}
        selectedValue={practiceGroupLevel}
        list={practiceGroupLevelOptions}
        required
        placeholder='Select a Practice Group Level'
      />
      <SelectionCheckbox
        id='select-include-higher-levels'
        label={
          <>
            Include the selected level as well as higher levels.
            <br />
            Note: Data will not be a one to one comparison.
          </>
        }
        checked={includeHigherLevels}
        setChecked={setIncludeHigherLevels}
      />
    </div>
  );
};

const getPracticeGroupLevelOptions = maxLevel =>
  Array.from({ length: MAX_PRACTICE_GROUP_LEVEL }).map((_, index) => {
    const level = index + 1;
    return {
      label: `Level ${level}`,
      value: level,
      disabled: level > maxLevel
    };
  });

export default PracticeGroupLevelSelection;
